import { ClientCSSProps } from '@ph-core/enums/client-css.enum';
import { Colors } from '@ph-env/model/environment.model';

import { setCssVariable } from './css-replacer.util';

export function setClientCssValues(colors: Colors): void {
  (Object.keys(colors) as (keyof Colors)[]).forEach((prop) => {
    const value = colors[prop];
    const cssVarName = ClientCSSProps[prop as keyof typeof ClientCSSProps];
    if (value && cssVarName) {
      setCssVariable(cssVarName, value);
    }
  });
}

/** Applies code-owned colors from the active environment. */
export function applyClientCssValues(colors: Colors): void {
  setClientCssValues(colors);
}
